import React, { useState } from 'react';
import styled from 'styled-components';
import { sizes, colors, width } from 'styles/variables';

export default props => {
	const lang = props.pageContext.lang || '';
	const [translations] = useState(require(`data/${lang}_translations`));
	console.log(translations);

	const Wrapper = styled.div`
		width: 100%;
		max-width: ${width.min}px;
		background: ${colors.background[2]};
		padding: ${sizes[0]};
		border-radius: 100px;
		margin: 0 auto;
		a {
			font-size: 0.9rem;
			padding: ${sizes[1]} ${sizes[2]};
			width: 50%;
			text-align: center;
			border-radius: 100px;
			color: ${colors.foreground[2]};
		}
		.--active {
			background: ${colors.background[0]};
			color: ${colors.foreground[0]};
		}
	`;

	return (
		<Wrapper>
			<a
				href="/"
				onClick={e => props.form.units(e)}
				className={props.form.get.metric ? '--active' : '--inactive'}
			>
				{translations.metric}
			</a>
			<a
				href="/"
				onClick={e => props.form.units(e)}
				className={!props.form.get.metric ? '--active' : '--inactive'}
			>
				{translations.imperial}
			</a>
		</Wrapper>
	);
};
